import React from 'react';
import TableBilling from '../../../../component/TableBilling/TableBilling';
import { Badge, Button } from 'react-bootstrap';
import { MdHistory } from 'react-icons/md';
import { TAB_LIST } from '../../../../BillingUsage';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import { formatCurrencyHasSymbol } from '../../../../../../utils/commonFunctions';
export const formatDateBilling = (timestamp) => {
  if (!timestamp || timestamp === 0) return I18n.t('billingUsage.noExpiry');
  timestamp = timestamp * 1000;
  return moment(timestamp).format('MMM D, YYYY');
};

export const formatDateBillingNotYear = (timestamp) => {
  if (!timestamp || timestamp === 0) return I18n.t('billingUsage.noExpiry');
  timestamp = timestamp * 1000;
  return moment(timestamp).format('MMM D');
};

const getColumns = (billingUsage) => [
  {
    title: I18n.t('billingUsage.received'),
    dataIndex: 'effectiveAt',
    render: (v) => formatDateBilling(v),
  },
  {
    title: I18n.t('billingUsage.state'),
    dataIndex: 'status',
    render: (v, r) => {
      let isActive = v === 'active' ? true : false;
      if (r.expiresAt && r.expiresAt * 1000 < Date.now()) {
        isActive = false;
      }
      return (
        <span className={isActive ? 'statusCredit bg-success' : 'statusCredit bg-danger'}>
          {isActive ? I18n.t('billingUsage.active') : I18n.t('billingUsage.expired')}
        </span>
      )
    },
  },
  {
    title: I18n.t('billingUsage.balance'), render: (_, r) => `${formatCurrencyHasSymbol(r.grantUsed, billingUsage?.currencyISO)} / ${formatCurrencyHasSymbol(r.grantAmount, billingUsage?.currencyISO)}`
  },
  {
    title: I18n.t('billingUsage.expires'),
    dataIndex: 'expiresAt',
    render: (v) => formatDateBilling(v),
  },
];

export default function CreditGrantsPage({ data = [], billingUsage, onTabSelect }) {
  const footerText = I18n.t('billingUsage.creditsListedHereWillBeRemoved');
  const columns = getColumns(billingUsage);
  console.log('billingUsage', billingUsage);
  return (
    <div className="p-4 billing-table-container">
      <div className="table-header-billing d-flex justify-content-between align-items-center">
        <h4>{I18n.t('billingUsage.creditGrants')}</h4>
        <div className="d-flex align-items-center rightContent">
          <span className="last-7-days">{I18n.t('billingUsage.last7Days')}</span>
          <Button
            variant="link"
            size="sm"
            className="billing-btn"
            onClick={() => onTabSelect(TAB_LIST.creditGrants)}
          >
            <MdHistory size={16} className="mr-1" />
            {I18n.t('billingUsage.viewHistory')}
          </Button>
        </div>
      </div>
      <TableBilling data={data} columns={columns} footerText={footerText} />
    </div>
  );
}
